"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

import { ENV } from "#app/env";
import { TimeSpan } from "#app/lib/TimeSpan";
import { Spinner } from "#ui/spinner";

import { useAuthVendorWidgetLoad } from "./use-authvendor-widget";

/** Shared by the token query interval and the widget staleness gate, which must not drift apart. */
export const AUTH_VENDOR_WIDGET_REFRESH_INTERVAL_MS = TimeSpan.fromMinutes(
  ENV.pingWidgetRefreshIntervalMins,
).totalMilliseconds;

interface AuthVendorWidgetParams extends React.PropsWithChildren {
  accessToken: string;
  companyId: string;
  policyId: string;
  widgetContainerSelector: string;
  extraParameters: {};
  widgetTokenTimeout?: number;
  onSuccess: (event: any) => void;
  onError: (event: any) => void;
  onWidgetReactivated?: () => Promise<unknown>;
  widgetRefreshIntervalMs?: number;
}

export default function AuthVendorWidget({
  accessToken,
  companyId,
  policyId,
  widgetContainerSelector,
  extraParameters,
  onSuccess,
  onError,
  widgetTokenTimeout,
  onWidgetReactivated,
  widgetRefreshIntervalMs,
}: AuthVendorWidgetParams) {
  const [isWidgetScriptReady, setIsWidgetScriptReady] = useState(false);
  const [isDavinciScriptReady, setIsDavinciScriptReady] = useState(false);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window?.davinci) {
        setIsDavinciScriptReady(true);
        clearInterval(intervalId);
      }
    }, 200);
    return () => clearInterval(intervalId);
  }, []);
  useAuthVendorWidgetLoad({
    accessToken,
    companyId,
    policyId,
    widgetContainerSelector,
    extraParameters,
    onSuccess,
    onError,
    widgetTokenTimeout,
    isWidgetScriptReady,
    onWidgetReactivated,
    widgetRefreshIntervalMs,
  });

  return (
    <>
      <Script
        src="https://assets.pingone.com/davinci/latest/davinci-no-css.js"
        onReady={() => setIsDavinciScriptReady(true)}
      />
      {isDavinciScriptReady ? (
        <Script
          id="baird-authvendorwidgetinator"
          src="/scripts/authvendorwidget.js"
          onReady={() => setIsWidgetScriptReady(true)}
        />
      ) : null}
      <div id="widget" className="skWidget center">
        <Spinner size="lg" className="mx-auto" />
      </div>
    </>
  );
}
